import { render, staticRenderFns } from "./ModalTransfers.vue?vue&type=template&id=63c26334&lang=pug&"
import script from "./ModalTransfers.vue?vue&type=script&lang=js&"
export * from "./ModalTransfers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports